import React, {useState} from "react";
import RegularText from "../../common/_RegularText";
import {Button, Modal} from "../../common";
import styles from "../../common/_Modal/_Modal.module.scss";
import axios from "axios";
import {useAppState} from "../../../state";
import {INBOX_CONVERTED_BUSINESS} from "../../../state/reducers/alertReducer";

const convertInboxBusiness = (id, setLoading, dispatch) => {
    return axios.post("/api/payreq-accounts/convert-to-business-inbox", {accountId: id})
        .then(() => {
            dispatch({type: INBOX_CONVERTED_BUSINESS})
        })
        .finally(() => {
            setLoading(false);
        });
};

const ConvertInboxBusinessModal = ({accountId, show, setShow, handleChange}) => {

    const [loading, setLoading] = useState(false);
    const [, dispatch] = useAppState();

    return <Modal header={"accounts.convertModal.businessHeader"} show={show} setShow={setShow} handleClose={() => setShow(false)}>
        <RegularText text="accounts.convertModal.businessMessage"/>
        <Modal.Footer>
            <Button label={"accounts.convertModal.cancel"} variant={"secondary"}
                    onClick={() => setShow(false)}/>
            <Button label={"accounts.convertModal.convert"} variant={"primary"} loading={loading}
                    onClick={() => {
                        convertInboxBusiness(accountId, setLoading, dispatch)
                            .then(() => {
                                handleChange()
                                setShow(false)
                            })
                    }} className={styles.submitButton}/>
        </Modal.Footer>
    </Modal>
};
export {ConvertInboxBusinessModal};